module.exports = __webpack_public_path__ + "media/nujabes-love-sick-part-2.ec8839d9.mp3";